import { SearchItem } from './module';

export enum HoldingType {
  Index = 'index',
  Vertical = 'vertical',
}
export interface HoldingSearchItemData {
  holdingName: string;
  holdingType: HoldingType | undefined;
}
export const HoldingModuleId = 'Holdings of' as const;
export const HoldingSearchItemVersion = '1' as const;
export interface HoldingSearchItem extends SearchItem<HoldingSearchItemData> {
  version: typeof HoldingSearchItemVersion;
  moduleId: typeof HoldingModuleId;
}
export const isHoldingSearchItem = (item: SearchItem): item is HoldingSearchItem =>
  item.moduleId === HoldingModuleId && item.version === HoldingSearchItemVersion;

export const createHoldingSearchItem = (holdingName: string, holdingType: HoldingType | undefined = undefined) => ({
  data: {
    holdingName,
    holdingType,
  },
  id: holdingName,
  moduleId: HoldingModuleId,
  version: HoldingSearchItemVersion,
});
